import { FC } from "react";
import { Column, Row } from "../../../components/containers";
import {
  AlignItems,
  JustifyContent,
} from "../../../components/containers/types";
import { Heading } from "../../../components/typography";
import { useWidgetStore, useThemeStore } from "../../../stores";
import { Button } from "../../../components/buttons";
import EditItemRenderer from "./edit-item-renderer";

const DashboardSettings: FC = () => {
  const theme = useThemeStore((s) => s.theme);
  const items = useWidgetStore((s) => s.items);
  const addItem = useWidgetStore((s) => s.addItem);

  return (
    <Row
      style={{
        width: "100%",
        margin: "1rem",
        borderRadius: 15,
      }}
      gap={50}
      justifyContent={JustifyContent.Start}
    >
      <Column gap={10} alignItems={AlignItems.Start} style={{ width: "100%" }}>
        <Heading color={theme.textOnBg} size={20}>
          تنظیمات داشبورد
        </Heading>
        <div
          style={{
            width: "calc(100% - 4rem)",
            borderRadius: 15,
            padding: "2rem",
            background: theme.overlay,
          }}
        >
          {items.map((item) => (
            <EditItemRenderer item={item} key={item.id} />
          ))}

          <Row justifyContent={JustifyContent.End}>
            <Button
              onClick={() => addItem([])}
              background={theme.primary}
              color={theme.textOnprimary}
            >
              افزودن لایه
            </Button>
          </Row>
        </div>
      </Column>
    </Row>
  );
};

export default DashboardSettings;
